module.exports = __webpack_public_path__ + "static/media/bg-default-blog.32ed4e6d.png";